import { Paragraph } from "./Text";
import { useColors } from "./useColors";

export const Divider = () => {
  const { subtitleColor } = useColors();

  return (
    <Paragraph align="center" color={subtitleColor}>
      ⁂
    </Paragraph>
  );
};
